"use client";

import React, { useEffect, useRef } from "react";
import { useAction, useConvexAuth } from "convex/react";
import { api } from "@repo/backend/convex/_generated/api";

/**
 * Sign-in bootstrap. Provisions the per-board `users` row (ensureAccount) before
 * syncing billing so the Autumn customer keys off the right row, then refreshes
 * the reactive billingState mirror (the autumn-js React provider is gone — see
 * useBillingState).
 */
export function AutumnClientProvider({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useConvexAuth();
  const ensureAccount = useAction(api.authz.ensureAccount);
  const ensureSynced = useAction(api.autumn.ensureBillingSynced);
  const syncedRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated) {
      syncedRef.current = false;
      return;
    }
    if (syncedRef.current) return;
    syncedRef.current = true;
    void (async () => {
      await ensureAccount({});
      await ensureSynced({});
    })().catch(() => {
      syncedRef.current = false;
    });
  }, [isAuthenticated, ensureAccount, ensureSynced]);

  return <>{children}</>;
}
